import React, { useState, useRef } from 'react';

import { Backdrop, useMediaQuery } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import { StyledAvatar } from 'components/avatars';
import { useHistory } from 'react-router-dom';
import { components } from 'react-select';
import AsyncSelect from 'react-select/async';
import styled from 'styled-components';

import { SEARCH_TAG_TYPES } from 'constants/ProjectConstants';
import { getProfileRoute, getTagDetailRoute, mobileDownMediaQuery, getColorFromKey } from 'constants/helper';
import { sendClickedViewProfileEvent, sendSearchEvent } from 'constants/mixpanelHelper';

import { employeeUniversalAutoSearch } from 'services/search';

import { Search } from 'uiToolkitV1/Search';

import { useMatchedRoute } from './hooks/useMatchedRoute';

const parseUniversalSearchAutoCompleteResV1 = (res, existingData) => {
  const result = [];

  let index = 0;
  const data = res;
  if (data && data.length > 0) {
    index++;
    result.push({
      label: 'EMPLOYEE_NAME',
      options: data.map(({ employee }) => ({
        label: employee?.displayName,
        value: `${'EMPLOYEE_NAME'}_${employee?.uuid}`,
        id: employee?.uuid,
        index,
        imageUrl: employee?.image,
        designation: employee?.designation ?? '',
        tagType: 'EMPLOYEE_NAME',
        email: employee?.email,
      })),
    });
  }
  return result;
};

/**
 * @deprecated 8-04-2025
 */
const UniversalSearchV1 = () => {
  const { pageName } = useMatchedRoute();
  const history = useHistory();

  const [searchText, setSearchText] = useState('');
  const searchBarEl = useRef(null);

  const isMobileView = useMediaQuery(mobileDownMediaQuery);

  const selectStyles = {
    menuList: (provided) => ({
      ...provided,
      maxHeight: '70vh',
      '::-webkit-scrollbar': {
        width: '5px',
      },
      '::-webkit-scrollbar-thumb': {
        background: getColorFromKey('grey'),
      },
    }),
    option: (provided, { imageUrl }) => ({
      ...provided,
      cursor: 'pointer',
      padding: imageUrl ? '10px 14px' : '14px',
      fontWeight: 600,
      borderBottom: '1px solid #e6ecf0',
      '&:hover': {
        background: 'rgba(230, 236, 240, 0.4)',
      },
    }),
    group: (provided) => ({
      ...provided,
      padding: 0,
    }),
    groupHeading: (provided) => ({
      ...provided,
      height: '12px',
      backgroundColor: 'rgb(230, 236, 240)',
      color: 'rgb(230, 236, 240)',
      padding: 0,
      margin: 0,
    }),
    loadingMessage: (provided) => ({
      ...provided,
      padding: '1em 14px',
    }),
  };

  if (isMobileView)
    selectStyles.control = (provided) => ({
      ...provided,
      height: '8vh',
      fontSize: '1rem',
    });

  const NoOptionsMessage = (props) => (
    <components.NoOptionsMessage {...props}>
      {searchText ? 'No results found' : 'Try searching for teams, tags, or employees'}
    </components.NoOptionsMessage>
  );

  const Option = (props) => {
    const { data } = props;
    return (
      <components.Option {...props} imageUrl={data.imageUrl}>
        {data.imageUrl && <StyledAvatar1 display="inline" size="icon" src={data.imageUrl} />}
        {data.label}
      </components.Option>
    );
  };

  const LoadingMessage = (props) => (
    <components.LoadingMessage {...props}>
      <>
        <Skeleton width="70%" />
        <Skeleton width="55%" />
      </>
    </components.LoadingMessage>
  );

  const handleInputChange = (value) => {
    sendSearchEvent({
      eventProperties: {
        searchQuery: value,
      },
    });
    setSearchText(value);
  };

  const loadOptions = async (text = '', callback, limit = 15) => {
    const res = await employeeUniversalAutoSearch({
      query: text,
      callback,
      limit,
      tagType: 'EMPLOYEE_NAME_AND_EMAIL',
    });
    const parsedRes = parseUniversalSearchAutoCompleteResV1(res);
    return parsedRes;
  };

  const handleChange = (option) => {
    searchBarEl.current.blur();
    let route;
    switch (option.tagType) {
      case SEARCH_TAG_TYPES.team:
        // const search = { id: option.id, name: option.label, type: 'CUSTOM_TYPE' };

        // history.push({
        //   pathname: routes.goals.audit,
        //   search: `?cohort=${encodeURIComponent(JSON.stringify(search))}`,
        // });
        // return;
        // route = getTeamPageRoute({ teamId: option.id, teamName: option.label });
        break;
      case SEARCH_TAG_TYPES.tag:
        // TODO: Sahil made it easy for you to get the route
        // Please check the correctness of the values
        // If # is present in query params, it would come as blank, hence replacing the #
        route = getTagDetailRoute({
          tagId: option.id,
          tagName: option.label.replace('#', ''),
          tagType: option.subType,
        });
        break;
      case SEARCH_TAG_TYPES.employee:
        sendClickedViewProfileEvent({
          eventProperties: {
            empId: option.id,
            source: 'Search',
            teamId: null,
            profileType: 'User',
          },
        });
        route = getProfileRoute(option.id);
        break;
      default:
        break;
    }
    setSearchText('');
    history.push(route);
  };

  return (
    <SearchInputContainer>
      <Search
        placeholder="Search Mesh"
        // components={{ LoadingMessage, NoOptionsMessage, Option }}
        defaultOptions
        loadOptions={loadOptions}
        onInputChange={handleInputChange}
        // classNamePrefix="react-select-custom"
        onChange={handleChange}
        menuPlacement="auto"
        value="searchText"
        // styles={selectStyles}
        ref={searchBarEl}
        defaultWidth="238px"
      />
      <StyledBackdrop open />
    </SearchInputContainer>
  );
};

const SearchInputContainer = styled.div``;

const SearchSelect = styled(AsyncSelect)`
  width: 100%;
  display: inline-block;
  .react-select-custom__control {
    border: 0;
    padding-left: 2rem;
    padding-right: 10%;
    box-shadow: none;
  }
  .react-select-custom__indicators {
    display: none;
  }
  .react-select-custom__group {
    &:first-child {
      .react-select-custom__group-heading {
        display: none;
      }
    }
    &:last-child {
      .react-select-custom__option {
        &:last-child {
          border: none;
        }
      }
    }
  }
  ${(props) => props.theme.breakpoints.up('sm')} {
    .react-select-custom__control {
      padding-left: 0.375rem;
      border-radius: 4px;
      border: 1px solid ${(props) => props.theme.palette.borders.lightGrey};
      &:focus-within {
        background-color: ${(props) => props.theme.palette.background.blue.light.v2};
        border: 1px solid ${(props) => props.theme.palette.borders.lightGrey};
      }
    }
    .react-select-custom__menu {
      min-width: 35vw;
    }
  }
`;

const StyledAvatar1 = styled(StyledAvatar)`
  display: inline-block;
  vertical-align: middle;
  height: 38px;
  width: 38px;
  margin-right: 10px;
`;

const StyledBackdrop = styled(Backdrop)`
  top: 52px;
  transform: scale(0);
  opacity: 0 !important;
  transition: all 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  ${SearchInputContainer}:focus-within & {
    transform: scale(1);
    opacity: 1 !important;
  }
`;

export default UniversalSearchV1;
